import { useTranslation } from 'react-i18next'
import {
    Box,
    InputAdornment,
    styled,
    TextField,
    Typography,
    useTheme,
} from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'
import moment from 'moment'
import { MUIDatePicker } from 'packages/eid-ui/DateTimePickers'

const DueDateInputContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '&:hover': {
        cursor: 'pointer',
        '& input': {
            cursor: 'pointer',
            borderColor: theme?.palette?.primary?.main,
        },
    },
}))
const DueDate = ({ dueDate, setDueDate }) => {
    const theme = useTheme()

    const { t } = useTranslation()
    const value = dueDate ? dueDate.clone().local() : null
    const label = t('Common_DueDate')

    const CustomField = (props) => {
        return (
            <TextField
                {...props}
                InputProps={{
                    ...props.InputProps,
                    startAdornment: !props.value ? (
                        <InputAdornment position="start">
                            <Typography
                                sx={{
                                    color: '#b4b4b4',
                                    fontSize: '0.9rem !important',
                                    textTransform: 'uppercase',
                                    width: '2.5rem',
                                    whiteSpace: 'normal',
                                }}
                            >
                                {t('Common_DueDate')}
                            </Typography>
                        </InputAdornment>
                    ) : (
                        props.InputProps.startAdornment
                    ),
                    endAdornment: (
                        <InputAdornment position="start">
                            <Icon
                                name="Tasks"
                                width={19}
                                height={20}
                                color="#959598"
                            />
                        </InputAdornment>
                    ),
                    sx: {
                        height: '4.2rem', // Set the height here
                        boxShadow: '0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
                        borderRadius: '0.5rem',
                        backgroundColor: theme?.palette?.background?.paper,
                        fontSize: '1.4rem !important',
                    },
                }}
                variant="outlined"
                label={''}
            />
        )
    }

    return (
        <DueDateInputContainer>
            <MUIDatePicker
                minDate={moment(new Date())}
                value={value}
                label={label}
                dateFormat="L"
                handleChange={(e) => {
                    if (isNilOrEmpty(e)) {
                        setDueDate(null)
                    } else {
                        const date = moment(e)
                        const dateToSet = date
                            .clone()
                            .endOf('day')
                            .set('milliseconds', 0)
                            .utc()
                        setDueDate(dateToSet)
                    }
                }}
                customComponents={{
                    field: CustomField,
                }}
            ></MUIDatePicker>
        </DueDateInputContainer>
    )
}

export default DueDate
